import Keycloak from 'keycloak-js';

import { authenticateCtUser } from 'utils/token';

const MIN_VALIDITY_SECONDS = 300;

let keycloakClient;

/**
 * @param {object} KeycloakInitOptions
 * @return {Promise<boolean>}
 */
export const initializeKeycloak = (options) => {
  return keycloakClient?.init(options);
};

/**
 * Check and refresh token if expired
 * @return {Promise<boolean>}
 */
export const refreshToken = async () =>
  await keycloakClient?.updateToken(MIN_VALIDITY_SECONDS).catch(keycloakClient?.login);

/**
 * @return {string}
 */
export const getToken = () => {
  return keycloakClient?.token;
};

/**
 * Initialize Keycloak and authenticate user
 * @param {object} authConfig - authentication configuration
 * @return {Promise<boolean>}
 */
export const authenticateUser = async (authConfig) => {
  keycloakClient = new Keycloak({
    url: authConfig.authServerUrl,
    realm: authConfig.realm,
    clientId: authConfig.resource,
  });

  const options = {
    onLoad: 'check-sso',
    promiseType: 'native',
  };

  return initializeKeycloak(options).then((authenticated) => {
    if (authenticated) {
      return authenticateCtUser(getToken());
    } else {
      return keycloakClient.login({
        idpHint: authConfig.idpHint,
      });
    }
  });
};
